"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultStakedRelayerAPI = void 0;
const big_js_1 = __importDefault(require("big.js"));
const vaults_1 = require("./vaults");
const utils_1 = require("../utils");
const transaction_1 = require("./transaction");
const collateral_1 = require("./collateral");
const fee_1 = require("./fee");
const __1 = require("..");
class DefaultStakedRelayerAPI extends transaction_1.DefaultTransactionAPI {
    constructor(api, btcNetwork, electrsAPI, account) {
        super(api, account);
        this.electrsAPI = electrsAPI;
        this.collateralAPI = new collateral_1.DefaultCollateralAPI(api);
        this.vaultsAPI = new vaults_1.DefaultVaultsAPI(api, btcNetwork);
        this.feeAPI = new fee_1.DefaultFeeAPI(api);
    }
    register(planckStake) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = this.api.tx.stakedRelayers.registerStakedRelayer(planckStake);
            yield this.sendLogged(tx, this.api.events.stakedRelayers.RegisterStakedRelayer);
        });
    }
    deregister() {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = this.api.tx.stakedRelayers.deregisterStakedRelayer();
            yield this.sendLogged(tx, this.api.events.stakedRelayers.DeregisterStakedRelayer);
        });
    }
    reportVaultTheft(vaultId, btcTxId, merkleProof, rawTx) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedVaultId = this.api.createType("AccountId", vaultId);
            [merkleProof, rawTx] = yield __1.getTxProof(this.electrsAPI, btcTxId, merkleProof, rawTx);
            const tx = this.api.tx.stakedRelayers.reportVaultTheft(parsedVaultId, merkleProof, rawTx);
            yield this.sendLogged(tx, this.api.events.stakedRelayers.VaultTheft);
        });
    }
    list() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const stakedRelayersMap = yield this.api.query.wrappedRelayerRewards.stake.entriesAt(head);
            return stakedRelayersMap.map((v) => utils_1.storageKeyToFirstInner(v[0]));
        });
    }
    getMonitoredVaultsCollateralizationRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const vaults = yield this.vaultsAPI.list();
            const collateralizationRates = yield Promise.all(vaults.filter(vault => vault.status.isActive).map((vault) => __awaiter(this, void 0, void 0, function* () {
                return [
                    vault.id,
                    yield this.vaultsAPI.getVaultCollateralization(vault.id),
                ];
            })));
            const map = new Map();
            collateralizationRates
                .filter(this.isMonitoredVaultCollateralizationDefined)
                .forEach((pair) => map.set(pair[0], pair[1]));
            return map;
        });
    }
    isMonitoredVaultCollateralizationDefined(pair) {
        return pair[1] !== undefined;
    }
    getLastBTCDOTExchangeRateAndTime() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const lastBTCDOTExchangeRate = yield this.api.query.exchangeRateOracle.exchangeRate.at(head);
            const lastBTCDOTExchangeRateTime = yield this.api.query.exchangeRateOracle.lastExchangeRateTime.at(head);
            return [lastBTCDOTExchangeRate, lastBTCDOTExchangeRateTime];
        });
    }
    getCurrentStateOfBTCParachain() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            return yield this.api.query.security.parachainStatus.at(head);
        });
    }
    getWrappingFees(stakedRelayerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const stake = utils_1.decodeFixedPointType(yield this.api.query.wrappedRelayerRewards.stake.at(head, stakedRelayerId));
            const rewardPerToken = utils_1.decodeFixedPointType(yield this.api.query.wrappedRelayerRewards.rewardPerToken.at(head));
            const rewardTally = utils_1.decodeFixedPointType(yield this.api.query.wrappedRelayerRewards.rewardTally.at(head, stakedRelayerId));
            const fees = __1.computeReward(new big_js_1.default(stake), new big_js_1.default(rewardPerToken), new big_js_1.default(rewardTally));
            return new big_js_1.default(utils_1.satToBTC(fees.toString()));
        });
    }
    getCollateralFees(stakedRelayerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const stake = utils_1.decodeFixedPointType(yield this.api.query.collateralRelayerRewards.stake.at(head, stakedRelayerId));
            const rewardPerToken = utils_1.decodeFixedPointType(yield this.api.query.collateralRelayerRewards.rewardPerToken.at(head));
            const rewardTally = utils_1.decodeFixedPointType(yield this.api.query.collateralRelayerRewards.rewardTally.at(head, stakedRelayerId));
            const fees = __1.computeReward(new big_js_1.default(stake), new big_js_1.default(rewardPerToken), new big_js_1.default(rewardTally));
            return new big_js_1.default(utils_1.planckToDOT(fees.toString()));
        });
    }
    getAPY(stakedRelayerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const [feesWrapped, feesCollateral, lockedCollateral] = yield Promise.all([
                yield this.getWrappingFees(stakedRelayerId),
                yield this.getCollateralFees(stakedRelayerId),
                yield this.collateralAPI.balanceLocked(stakedRelayerId),
            ]);
            return this.feeAPI.calculateAPY(feesWrapped, feesCollateral, lockedCollateral);
        });
    }
    getSLA(stakedRelayerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const sla = yield this.api.query.sla.relayerSla.at(head, stakedRelayerId);
            return Number(utils_1.decodeFixedPointType(sla));
        });
    }
    getMaxSLA() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const maxSLA = yield this.api.query.sla.relayerTargetSla.at(head);
            return Number(utils_1.decodeFixedPointType(maxSLA));
        });
    }
}
exports.DefaultStakedRelayerAPI = DefaultStakedRelayerAPI;
//# sourceMappingURL=staked-relayer.js.map